export const userNameRegx = /^[A-Za-z0-9@_]+$/;
export const phoneNumber = /[^0-9]/g;
export const name = /^[A-Za-z]+$/;
export const passwordValidation = /^\S+$/;
export const indianMobileNumber = /^[6-9]\d{9}$/i;
export const crrNumberRegex = /^[A-Z](?=.*\d)[A-Z\d]{5,6}$/